var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-icon',{attrs:{"size":"100"}},[_vm._v("cached")]),_c('div',{staticClass:"title"},[_vm._v("This functional logic is in development...")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }